/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: (props) => ({
        slidesStage: {
            display: 'block',
            position: 'fixed',
            bottom: props.stageInViewYPos,
            width: '100%',
            height: `calc(100vh - ${props.shrinkedHeaderHeight}px)`
            // border: '1px solid red',
            // opacity: '0.3'
        },
        slideContainer: {
            position: 'absolute',
            top: 0,
            width: '100%'
        },
        videoPlayer: {
            width: '100%',
            height: `calc(100vh - ${props.shrinkedHeaderHeight}px)`,
            objectFit: 'cover'
        },
        staticImage: {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: {base: 'bottom', lg: 'bottom right', xl: 0}
        },
        overlayContainer: {
            maxWidth: 'container.xxxl',
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '100%',
            height: '100vh',
            paddingX: 4,
            position: 'absolute',
            left: '50%',
            top: {base: '8%', lg: '0'},
            transform: 'translateX(-50%)',
            color: 'white',
            alignItems: {base: 'start', lg: 'center'}
        },
        overlayInnerContainer: {
            display: {base: 'block', lg: 'flex'},
            maxWidth: {lg: '480px', xl: '675px'}
        }
    }),
    variants: {},
    parts: [
        'slidesStage',
        'slideContainer',
        'videoPlayer',
        'staticImage',
        'overlayContainer',
        'overlayInnerContainer'
    ]
}
